import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const BannerWrapper = styled.div`
  width: 820px;
`;

export const LockImageWrapper = styled.div`
  background-color: ${tokens.BRAND_COLORS.noon_100};
  padding: 20px 97px;
  img {
    width: 90px;
  }
`;
